import { baseApi } from '../apiProvider';
import { ResponseImages } from '../models/response/responseImages';

const resourceAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // upload file
    postResource: builder.mutation<ResponseImages, FormData>({
      query: (formData) => ({
        url: '/v0/resources',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { usePostResourceMutation } = resourceAPI;
